import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

interface IDynamicModal {
  name: string;
  type: string;
}
@Module({ name: 'app', namespaced: true })
export default class AppModule extends VuexModule {
  appIsLoading: boolean = null;
  selectedModal: IDynamicModal = null;

  @Action
  setSelectedModal(selectedModal: IDynamicModal) {
    this.context.commit('SET_SELECTED_MODAL', selectedModal);
  }

  @Mutation
  SET_SELECTED_MODAL(selectedModal: IDynamicModal) {
    this.selectedModal = selectedModal;
  }

  @Action
  setAppIsLoading(appIsLoading: boolean) {
    this.context.commit('SET_APP_IS_LOADING', appIsLoading);
  }

  @Mutation
  SET_APP_IS_LOADING(appIsLoading: boolean) {
    this.appIsLoading = appIsLoading;
  }
}
